/**
 * Latvian translation for bootstrap-datepicker
 * Artis Avotins <artis@apit.lv>
 */

;(function($){
  $.fn.datepicker.dates['lv'] = {
    days: ["Svētdiena", "Pirmdiena", "Otrdiena", "Trešdiena", "Ceturtdiena", "Piektdiena", "Sestdiena"],
    daysShort: ["Sv", "P", "O", "T", "C", "Pk", "S"],
    daysMin: ["Sv", "Pr", "Ot", "Tr", "Ce", "Pk", "Se"],
    months: ["Janvāris", "Februāris", "Marts", "Aprīlis", "Maijs", "Jūnijs", "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jūn", "Jūl", "Aug", "Sep", "Okt", "Nov", "Dec"],
    monthsTitle: "Mēneši",
    today: "Šodien",
    clear: "Nodzēst",
    weekStart: 1,
    format: "dd.mm.yyyy"
  };
}(jQuery));
